import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#let (if (eq @direction \"desc\") \"down\" \"up\") as |icon|}}\n  <NwIcon @icon=\"icon-chevron-{{icon}}\" ...attributes />\n{{/let}}")